export const SortingOptions = ['price', '-price', 'recommended', '-created_at'] as const;
export type SortOption = (typeof SortingOptions)[number];
